<app-iota-modal [title]="dialogTitle()" [modalOptions]="modalOptions()" (close$)="onCancelClick()">
    <div modal-body>
        <div class="flex flex-col gap-5 items-center">
            <span *ngIf="confirmText">{{ confirmText }}</span>

            <app-note-list
                class="w-full"
                [notes]="notes()"
                [disabled]="busy()"
                (add)="addNote($event)"
                (delete)="removeNote($event)"
                *ngIf="isShowNotesDialog()"
            ></app-note-list>

            <pre class="w-full overflow-x-auto" *ngIf="isShowErrorDialog()">{{ errorText() }}</pre>

            <div class="alert alert-error shadow-lg" *ngIf="showActionError()">
                <div class="w-full flex flex-row gap-4">
                    <iota-icon icon="exclamation-triangle" [size]="1.5"></iota-icon>
                    <span *ngIf="isShowNotesDialog()" i18n>Error adding/removing comment!</span>
                    <span *ngIf="actionErrorText">{{ actionErrorText }}</span>
                </div>
            </div>
        </div>
    </div>

    <div modal-footer class="flex grow justify-between">
        <button class="btn btn-sm btn-ghost rounded-full" (click)="onCancelClick()" i18n>Cancel</button>
        <button
            class="btn btn-sm btn-primary rounded-full"
            [ngClass]="{ loading: busy() }"
            [disabled]="busy()"
            (click)="reject()"
            *ngIf="isRejectDialog()"
            i18n
        >
            Reject
        </button>
        <button
            class="btn btn-sm btn-primary rounded-full"
            [ngClass]="{ loading: busy() }"
            [disabled]="busy()"
            (click)="approve()"
            *ngIf="isApproveDialog()"
            i18n
        >
            Approve
        </button>
    </div>
</app-iota-modal>
